<template>
  <div style="display: flex;margin-bottom: 60px;">
    <div>
      <personalMenu :activeIndex="'4'"/>
    </div>
    <div class="published">
      <!--    <div class="projectName">{{ project.name }}</div>-->
      <el-tabs type="border-card" @tab-click="tabClick" v-model="active" v-if="isMyRelease == 1">
        <el-tab-pane v-for="(item, index) in publishedTitleList" :key="index" :label="item.title" :name="item.name">
          <div v-if="item.name === '1'">
            <projectInfoJianYi :projectId="id"/>
          </div>
          <div v-if="item.name === '2' && status == '0'">
            <div v-if="list.length === 0 " class="noContent">
              <img src="../../assets/img/public/empty_icon.png">
              <div style="width: 100%; text-align: center">暂无内容</div>
            </div>
            <div class="distributionBox" v-for="(item, index) in list" :key="index" @click="detail(item.id)">
              <div class="title ">
                <span class="address">{{ item.city }}</span>
                {{ item.title }}
              </div>
              <div class="personInformationBox">
                <div>
                  <img class="headImg"
                       src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default_lgsc.png"
                       v-if="!item.headImg">
                  <img :src="item.headImg" v-else class="headImg" @click.stop="imagePreview(item.headImg)">
                </div>
                <div class="personInformation">
                  <div class="name ">{{ item.name }}
                    <span class="auth isAuth" style="color: #10b96a !important;" v-if="item.isAuth == 1">已实名</span>
                    <span v-if="item.isAuth == 0" class="unAuth">未实名</span>
                  </div>
                  <div class="information">
                    {{ item.info }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.name === '3'">
            <div v-if="list.length === 0 " class="noContent">
              <img src="../../assets/img/public/empty_icon.png">
              <div style="width: 100%; text-align: center">暂无内容</div>
            </div>
            <div class="distributionBox" v-for="(item, index) in list" :key="index" @click="detail(item.id)">
              <div class="title ">
                <span class="address">{{ item.city }}</span>
                {{ item.title }}
              </div>
              <div class="personInformationBox">
                <div>
                  <img class="headImg"
                       src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default_lgsc.png"
                       v-if="!item.headImg">
                  <img :src="item.headImg" v-else class="headImg" @click.stop="imagePreview(item.headImg)">
                </div>
                <div class="personInformation">
                  <div class="name ">{{ item.name }}
                    <span class="auth isAuth" style="color: #10b96a !important;" v-if="item.isAuth == 1">已实名</span>
                    <span v-if="item.isAuth == 0" class="unAuth">未实名</span>
                  </div>
                  <div class="information">
                    <!--                    <span>{{ val.key }} </span>-->
                    {{ item.info }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <pagination
            v-if="item.name === '2' || item.name === '3'"
            v-show="total>0"
            :total="total"
            :page.sync="pageNum"
            :limit.sync="pageSize"
            @pagination="getpageList"
          />
          <div class="button" v-if="item.name === '1' && status == '0'">
            <el-button type="warning" @click="delProject" class="btnHeight_40 btWith_120">删除</el-button>
            <el-button type="primary" @click="reissue" class="btnHeight_40 btWith_120 mg_left_40">重新发布</el-button>
            <el-button type="success" @click="userEnough" class="btnHeight_40 btWith_120 mg_left_40">已招满</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div v-else class="bgf">
        <projectInfoJianYi :project="project"/>
        <template v-if="type == 2 && finishStatus == '1'">
          <hr class="type-hr">
          <div class="textTitle">状态</div>
          <div class="text type-text" style="color: #F2B72D">已经申请完工，请等待</div>
        </template>
        <div class="smallBottom" v-if="type == 2 && finishStatus == '0'">
          <el-button type="primary" @click="applyCompletion" class="btnHeight_40 btWith_120 ">申请完工</el-button>
        </div>
        <div class="bottom" v-if="type == 2 && finishStatus == '2'">
          <el-button class="btnHeight_40 btWith_240 " type="primary" @click="rejectionReasons">
            完工申请被驳回，点击查看
          </el-button>
        </div>
      </div>

      <el-dialog
        :visible.sync="userInfoDialog"
        width="30vw"
        center
      >
        <div class="distributionBox">
          <div class="title ">
            <span class="address">{{ detailData.city }}</span>
            {{ detailData.title }}
          </div>
          <div class="personInformationBox">
            <div>
              <img class="headImg"
                   src="http://yiyong-pub.oss-cn-shanghai.aliyuncs.com/ygwApplet/getJob/touxiang_default_lgsc.png"
                   v-if="!detailData.headImg">
              <img :src="detailData.headImg" v-else class="headImg" @click.stop="imagePreview(detailData.headImg)">
            </div>
            <div class="personInformation">
              <div class="name ">{{ detailData.name }}</div>
              <div class="information" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id !== 'score'">
                <span>{{ val.key }} </span>
                {{ val.value }}
              </div>
              <div class="WRAST" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id === 'score'">
                <span class="text">{{ val.key }} </span>
                <span class="WRASText" v-if="val.value.socreLevel == -1">黑名单</span>
                <span class="WRASText" v-if="val.value.socreLevel == 0">信用未评级</span>
                <img src="../../assets/img/paihuo/star_one.png" class="star_one"
                     v-if="val.value.starCount === 1">
                <img src="../../assets/img/paihuo/star_two.png" class="star_two"
                     v-if="val.value.starCount === 2">
                <img src="../../assets/img/paihuo/star_three.png" class="star_three"
                     v-if="val.value.starCount === 3">
                <img src="../../assets/img/paihuo/star_four.png" class="star_four"
                     v-if="val.value.starCount === 4">
                <img src="../../assets/img/paihuo/star_five.png" class="star_five"
                     v-if="val.value.starCount === 5">
              </div>
            </div>
          </div>
        </div>
        <div class="box" v-for="(item, index) in detailData.detailDatas" :key="index">
          <span class="title">{{ item.key }}</span>
          <span class="value">{{ item.value }}</span>
        </div>
        <div slot="footer">
          <el-button type="warning" @click="agreeAccept" class="btnHeight_40 btWith_120" v-if="userInfoType == 1">同意签约
          </el-button>
          <el-button type="primary" @click="simpleFinish" class="btnHeight_40 btWith_120"
                     v-if="userInfoType == 2 && status !== 6 && detailData.isFinish == 0">完工
          </el-button>
          <el-button type="warning" @click="userInfoDialog = false" class="btnHeight_40 btWith_120">返回</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="simpleFinishDialog"
        width="30vw"
        center
      >
        <div class="FinishText">已经完工，请前往APP给他评价下吧！</div>
        <div slot="footer">
          <el-button type="primary" @click="simpleFinishDialog = false" class="btnHeight_40 btWith_120">我知道了</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getSimpleProjectInfo,
  getProjectSigns,
  getProjectAccepts,
  delProject,
  userEnough,
  getSignDetail,
  agreeAccept,
  simpleFinish,
  getAcceptDetail,
  getFinishStatus,
  finishApply
} from '@api/project'
import projectInfoJianYi from '@views/components/projectInfoJianYi'
import personalMenu from "@views/layout/components/personalMenu";

export default {
  name: 'published',
  components: {
    projectInfoJianYi,
    personalMenu
  },
  data() {
    return {
      publishedTitleList: [
        {name: '1', title: '项目详情'},
        {name: '2', title: '报名人员'},
        {name: '3', title: '签约人员'}
      ],
      active: '1',
      status: '',
      project: {},
      pageSize: 20,
      pageNum: 0,
      id: '',
      type: '',
      incomeListLoading: false,
      listLoadFinished: false,
      list: [],
      total: 0,
      userInfoDialog: false,
      joinId: '',
      detailData: {},
      userInfoType: '',
      simpleFinishDialog: false
    }
  },
  created() {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.status = this.$route.query.status
    this.isMyRelease = this.$route.query.isMyRelease
    // 我发布的
    console.log(this.status)
    if (this.isMyRelease == '1') {
      if (this.status != 0) {
        this.publishedTitleList = [
          {name: '1', title: '项目信息'},
          {name: '3', title: '签约人员'}
        ]
      }
      this.getSimpleProjectInfo()
    } else {
      // 我参与的
      this.getSimpleProjectInfo()
      if (this.type === '2') {
        this.getFinishStatus()
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next(0)
  },

  methods: {
    // 获取项目详情
    getSimpleProjectInfo() {
      getSimpleProjectInfo({id: this.id}).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    tabClick() {
      this.pageNum = 1
      this.pageSize = 20
      this.total = 0
      this.list = []
      this.incomeListLoading = true
      this.listLoadFinished = false
      if (this.active === '1') {
        this.getSimpleProjectInfo()
      } else if (this.active === '2') {
        this.getProjectSigns()
      } else {
        this.getProjectAccepts()
      }
    },
    getpageList() {
      this.list = []
      this.total = 0
      if (this.active === '2') {
        this.getProjectSigns()
      } else if (this.active === '3') {
        this.getProjectAccepts()
      }
    },
    // 获取项目状态
    getFinishStatus() {
      getFinishStatus({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.finishStatus = res.data.data.finishStatus
          this.finishId = res.data.data.finishId
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 我发布的 分页获取简易项目报名人员
    getProjectSigns() {
      this.incomeListLoading = true
      getProjectSigns({
        projectId: this.id,
        pageNum: this.pageNum,
        pageSize: 20
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.list = res.data.data.rows
            this.total = res.data.data.totalRows
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    // 我发布的 分页获取简易项目签约人员
    getProjectAccepts() {
      this.incomeListLoading = true
      getProjectAccepts({
        projectId: this.id,
        pageNum: this.pageNum,
        pageSize: 20
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.list = res.data.data.rows
            this.total = res.data.data.totalRows
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    detail(id) {
      this.joinId = id
      let type = this.active === '2' ? 1 : 2
      this.userInfoType = type
      this.userInfoDialog = true
      if (type === 1) {
        // 获取报名信息
        this.getSignDetail()
      } else {
        // 获取签约信息
        this.getAcceptDetail()
      }
    },
    // 获取报名信息
    getSignDetail() {
      getSignDetail({
        joinId: this.joinId,
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取签约信息
    getAcceptDetail() {
      getAcceptDetail({
        joinId: this.joinId,
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    delProject() {
      this.$confirm('确认删除该项目吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delProject({id: this.id}).then(res => {
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            // 延迟1秒
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 重新发布
    reissue() {
      this.enterRouter('reissuePage', {projectId: this.id})
    },
    // 已招满
    userEnough() {
      userEnough({id: this.id}).then(res => {
        if (res.data.code === 200) {
          this.$message.success('操作成功')
          // 延迟1秒
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 同意签约
    agreeAccept() {
      agreeAccept({
        joinId: this.joinId,
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('操作成功')
          this.getpageList()
          this.userInfoDialog = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 完工
    simpleFinish() {
      simpleFinish({
        joinId: this.joinId,
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.getpageList()
          this.userInfoDialog = false
          this.simpleFinishDialog = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    applyCompletion() {
      // 单位标识：0-招标方；1-投标方
      // finishFlag:项目完工标识：0-未申请；1-申请中；2-被驳回;3-申请已通过
      this.$confirm('确认发送完工申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 发送完工申请
        this.applySubmit()
      })
    },
    applySubmit() {
      finishApply({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success('操作成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.published {
  margin-left: 10px;
  width: 990px;
  margin-top: 20px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 20px #e6e6e6;
  overflow-y: auto;

  .el-tabs--border-card {
    border: 0;
    box-shadow: #FFFFFF;
    min-height: 400px;
  }

  .auth {
    background-color: #096CEF12;
    padding: 3px 5px;
    font-size: 12px;
    border-radius: 3px;
    color: #096CEFFF;
    border: 1px solid #8DBEFE;
  }

  .unAuth {
    background-color: #F9F9F9FF;
    padding: 3px 5px;
    font-size: 12px;
    border-radius: 3px;
    color: #999999FF;
    border: 1px solid #EEEEEEFF;
  }

  .button {
    width: 440px;
    margin: 0 auto;
    margin-bottom: 40px;
  }

  .box {
    font-size: 16px;

    .title {
      display: inline-block;
      width: 100px;
      color: #999999;
      font-weight: bold;
    }

    .value {
      color: #333333;
    }
  }

  .FinishText {
    text-align: center;
    color: #333333;
    font-size: 20px;
  }

  .smallBottom {
    width: 140px;
    margin: 0 auto;
  }
}
</style>
